<template>
    <div id="packer_command_center">
        <div class="ui card">
            <div class="ui top attached buttons" v-if="!is_processing">
                <button
                    v-for="scanner_mode in scanner_modes"
                    :scanner_mode="scanner_mode"
                    class="ui basic button"
                    :class="{primary: current_scanner_mode == scanner_mode}"
                    @click="change_scanner_mode(scanner_mode)"
                >
                    {{ $t('packer.' + scanner_mode) }}
                </button>
            </div>
            <div class="ui buttons" v-else>
                <button
                    v-for="scanner_mode in scanner_modes"
                    :scanner_mode="scanner_mode"
                    class="ui basic button"
                    :class="{active: current_scanner_mode == scanner_mode}"
                >
                    {{ $t('packer.' + scanner_mode) }}
                </button>
            </div>
            <div class="content">
                <div class="ui fluid input" v-if="!is_processing">
                    <input
                    id="command_input_field"
                    type="text"
                    :placeholder="$t('packer.command_placeholder')"
                    v-model="barcode"
                    @keyup.enter.prevent="commands"
                    @keyup.up="change_scanner_mode('up')"
                    @keyup.down="change_scanner_mode('down')"
                    >
                </div>
                <div class="ui fluid disabled input" v-else>
                    <input type="text" :placeholder="$t('packer.command_placeholder')">
                </div>
            </div>
            <div class="extra content">
                <button class="ui right floated basic positive button" v-if="!is_processing" @click="submit">送出結果</button>
                <button class="ui right floated basic positive loading button" v-else>送出結果</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        is_processing: Boolean,
        scanner_modes: Array,
        current_scanner_mode: String,
    },
    data: function() {
        return {
            barcode: null,
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
        var that = this;
        $(document).on("keypress", function() {
            $("#command_input_field").focus();
        });
    },
    mounted: function() {
    },
    methods: {
        commands: function() {
            var that = this;
            var barcode = that.barcode;
            that.barcode = null;
            that.$bus.$emit("packer_command_center", "commands", barcode);
        },
        change_scanner_mode: function(mode) {
            var that = this;
            that.$bus.$emit("packer_command_center", "change_scanner_mode", mode);
        },
        submit: function() {
            var that = this;
            that.$bus.$emit("packer_command_center", "submit", null);
        },
    },
    components: {
    }
}
</script>
